/* Industrialsafety-UK cut-list cart page. Needs isu-search-core.js (window.ISUS). 2-10-2026 */
(function () {
  'use strict';
  var root = document.querySelector('[data-isu-cart]');
  if (!root) return;
  var app = root.querySelector('[data-isu-cart-app]');
  var S = window.ISUS;
  var D;
  try { D = JSON.parse(document.getElementById('isu-cart-data').textContent); } catch (e) { return; }
  if (!S || !app) return;
  var fb = root.querySelector('[data-isu-cart-fallback]');
  var cart = D.cart, VAT = 1 + (D.vat || 0) / 100, metaRows = D.meta || {}, meta = {};
  var e = S.esc, money = S.money;
  var SKEY = 'isu-saved-v1';
  var st = { inc: true, busy: false, msg: '', undo: null, disc: '' };
  /* 5-10-2026: prices are always shown inc VAT (no ex VAT view anywhere) */
  var timers = {};

  /* custom-size orders (hidden product "custom-cut-to-length"): all lines of one order share the
     _mtm / _cutlen property and are shown as one line without quantity steppers (3-10-2026) */
  function gid(it) { var p = it.properties || {}; return p._mtm || p._cutlen || p._m4u || ''; } /* _m4u = metals4u custom cut size (9-10-2026) */
  function view() {
    var out = [], g = {};
    cart.items.forEach(function (it) {
      var id = gid(it), p = it.properties || {};
      if (!id) { out.push(it); return; }
      if (!g[id]) {
        g[id] = { grp: id, key: 'grp:' + id, items: [], quantity: 1, final_line_price: 0, original_line_price: 0, properties: {}, product_title: p.For || it.product_title, url: p._url || '' };
        out.push(g[id]);
      }
      var x = g[id];
      x.items.push(it);
      x.final_line_price += it.final_line_price;
      x.original_line_price += it.original_line_price;
      Object.keys(p).forEach(function (k) { if (k !== 'For' && k !== 'Total' && k.charAt(0) !== '_' && p[k]) x.properties[k] = p[k]; });
    });
    return out;
  }
  function count() { return view().reduce(function (n, it) { return n + (it.grp ? 1 : it.quantity); }, 0); }
  function grpText(it) { return Object.keys(it.properties).map(function (k) { return k + ': ' + it.properties[k]; }).join('; '); }

  function M(pid) {
    if (meta[pid]) return meta[pid];
    var r = metaRows[pid];
    if (!r) return null;
    meta[pid] = S.prep(r);
    return meta[pid];
  }
  function saved() { try { return JSON.parse(localStorage.getItem(SKEY)) || []; } catch (x) { return []; } }
  function setSaved(a) { try { localStorage.setItem(SKEY, JSON.stringify(a)); } catch (x) {} }

  /* ---------- line maths ---------- */
  function maxCut(m) { var v = m && parseFloat(m.cut); return v > 0 ? v : 0; }
  function piecesOf(it) {
    var p = it.properties || {}, v = p['Cut into'];
    var min = minPieces(it);
    if (v) { var mm = String(v).match(/^(\d+)\s*[×x]/); var n = mm ? +mm[1] : 1; return Math.max(n, min); }
    return min;
  }
  function minPieces(it) {
    var m = M(it.product_id), mc = maxCut(m);
    return mc ? Math.max(1, Math.ceil(it.quantity / mc - 1e-9)) : 1;
  }
  function isLin(it) { var m = M(it.product_id); return !!(m && m.lin); }
  function cutText(len, pcs) {
    var mm = Math.round(len * 1000 / pcs);
    return pcs > 1 ? pcs + ' × ' + mm + ' mm' : 'One length of ' + Math.round(len * 1000) + ' mm';
  }
  function kgOf(it) {
    var m = M(it.product_id);
    if (m && m.lin && m.kg) return m.kg * it.quantity;
    if (it.grams) return it.grams * it.quantity / 1000;
    return 0;
  }
  function px(c) { return st.inc ? c : Math.round(c / VAT); }
  function totals() {
    var t = { lines: view().length, m: 0, kg: 0, pcs: 0, longest: 0 };
    cart.items.forEach(function (it) {
      t.kg += kgOf(it);
      if (isLin(it)) {
        var p = piecesOf(it);
        t.m += it.quantity; t.pcs += p;
        t.longest = Math.max(t.longest, Math.round(it.quantity * 1000 / p));
      } else t.pcs += 0;
    });
    return t;
  }

  /* ---------- api ---------- */
  function api(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function badge() {
    document.querySelectorAll('.isu-ic--cart').forEach(function (a) {
      var b = a.querySelector('.isu-ic__n'), n = count();
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('b'); b.className = 'isu-ic__n'; a.appendChild(b); }
      b.textContent = n; b.setAttribute('aria-label', n + ' items in basket');
    });
  }
  function refresh() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cart = c; badge(); render(); return c; }); }
  function change(it, qty, props) {
    var body = { id: it.key, quantity: qty };
    if (props) body.properties = props;
    return api('/cart/change.js', body).then(function (c) { cart = c; badge(); render(); return c; })
      .catch(function (err) { st.msg = (err && (err.description || err.message)) || 'Sorry, that change could not be saved.'; refresh(); });
  }
  function propsFor(it, pcs) {
    var p = {}, src = it.properties || {};
    Object.keys(src).forEach(function (k) { if (src[k] != null && src[k] !== '') p[k] = src[k]; });
    if (isLin(it)) p['Cut into'] = cutText(it.quantity, pcs);
    return p;
  }

  /* ---------- render ---------- */
  function chip(t, cls) { return t ? '<span class="isu-cchip' + (cls ? ' ' + cls : '') + '">' + e(t) + '</span>' : ''; }
  function stepper(kind, key, val, unit, min) {
    return '<div class="isu-step" data-key="' + e(key) + '" data-kind="' + kind + '"><button type="button" data-d="-1" aria-label="Less"' + (val <= min ? ' disabled' : '') + '>−</button>' +
      '<input type="text" inputmode="numeric" value="' + val + '" aria-label="' + (kind === 'len' ? 'Length in metres' : kind === 'pcs' ? 'Number of pieces' : 'Quantity') + '"><span class="isu-step__u">' + unit + '</span>' +
      '<button type="button" data-d="1" aria-label="More">+</button></div>';
  }
  function img(it, m) {
    var src = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || '');
    if (src) return '<img src="' + e(src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy" width="100" height="100">';
    return '<span class="isu-cimg__sw" style="background:' + (m && m.mat ? m.mat.c : '#c8ced6') + '"></span>';
  }
  function groupHtml(g) {
    var mtm = g.grp.charAt(0) === 'M';
    var props = Object.keys(g.properties).map(function (k) { return '<li>' + e(k) + ': ' + e(g.properties[k]) + '</li>'; }).join('');
    var t = g.url ? '<a class="isu-cline__t" href="' + e(g.url) + '">' + e(g.product_title) + '</a>' : '<span class="isu-cline__t">' + e(g.product_title) + '</span>';
    return '<div class="isu-cline" data-line="' + e(g.key) + '">' +
      '<span class="isu-cimg"><span class="isu-cimg__sw" style="background:#c8ced6"></span></span>' +
      '<div class="isu-cline__info">' + t + '<div class="isu-cline__chips">' + chip(g.grp.charAt(0) === 'K' ? 'Custom cut size' : (mtm ? 'Made to measure' : 'Cut to length'), 'is-strong') + '</div>' +
      (props ? '<ul class="isu-cline__props">' + props + '</ul>' : '') + '</div>' +
      '<div class="isu-cline__acts"><button type="button" data-remove="' + e(g.key) + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>Remove</button></div>' +
      '<div class="isu-cline__cut"><p class="isu-cline__hint">Made to order. To change the sizes, remove this line and add it again from the product page.</p></div>' +
      '<div class="isu-cline__price">' + (g.original_line_price > g.final_line_price ? '<s>' + money(px(g.original_line_price)) + '</s>' : '') + '<strong>' + money(px(g.final_line_price)) + '</strong></div></div>';
  }
  function lineHtml(it) {
    if (it.grp) return groupHtml(it);
    var m = M(it.product_id), lin = isLin(it), pcs = lin ? piecesOf(it) : 0, min = lin ? minPieces(it) : 0, mc = maxCut(m);
    var name = m ? m.name + (m.dims.length ? ' ' + S.size(m, 'mm').replace(' mm', '') + ' mm' : '') : it.product_title;
    if (m && m.prof && m.prof.k === 'round' && m.dims.length === 1) name = m.name + ' Ø ' + S.trim(m.dims[0]) + ' mm';
    var unitPrice = it.final_price, per = lin ? ' per m' : ' each';
    var chips = (m && m.grade ? chip(m.grade, 'is-strong') : '') + (m && m.dims.length ? chip(S.size(m, 'in')) : '') + chip(money(px(unitPrice)) + per) +
      (!it.product_has_only_default_variant && it.variant_title && !(m && m.vc === 1) ? chip(it.variant_title) : '');
    var props = Object.keys(it.properties || {}).filter(function (k) { return k !== 'Cut into' && k.charAt(0) !== '_' && it.properties[k]; })
      .map(function (k) { return '<li>' + e(k) + ': ' + e(it.properties[k]) + '</li>'; }).join('');
    var cut = '';
    if (lin) {
      cut = '<div class="isu-cline__row"><span>Length</span>' + stepper('len', it.key, it.quantity, 'm', 1) + '</div>' +
        '<div class="isu-cline__row"><span>Cut into</span>' + stepper('pcs', it.key, pcs, 'pc', min) + '</div>' +
        '<div class="isu-cut-note"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.1 15.9M14.5 14.5 20 20M8.1 8.1 12 12"/></svg>' +
        (pcs > 1 ? 'Cut to ' + pcs + ' × ' + Math.round(it.quantity * 1000 / pcs) + ' mm' : 'Supplied as one length of ' + Math.round(it.quantity * 1000) + ' mm') + '</div>' +
        (mc && it.quantity > mc ? '<p class="isu-cline__hint">Longest single bar ' + S.trim(mc) + ' m — longer runs are cut into pieces automatically</p>' : '');
    } else {
      cut = '<div class="isu-cline__row"><span>Quantity</span>' + stepper('qty', it.key, it.quantity, '', 1) + '</div>';
    }
    var kg = kgOf(it);
    return '<div class="isu-cline" data-line="' + e(it.key) + '">' +
      '<a class="isu-cimg" href="' + e(it.url) + '">' + img(it, m) + '</a>' +
      '<div class="isu-cline__info"><a class="isu-cline__t" href="' + e(it.url) + '" title="' + e(it.product_title) + '">' + e(name) + '</a><div class="isu-cline__chips">' + chips + '</div>' +
      (props ? '<ul class="isu-cline__props">' + props + '</ul>' : '') + '</div>' +
      '<div class="isu-cline__acts"><button type="button" data-save="' + e(it.key) + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 3h12v18l-6-4-6 4z"/></svg>Save for later</button>' +
      '<button type="button" data-remove="' + e(it.key) + '"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>Remove</button></div>' +
      '<div class="isu-cline__cut">' + cut + '</div>' +
      '<div class="isu-cline__price">' + (it.original_line_price > it.final_line_price ? '<s>' + money(px(it.original_line_price)) + '</s>' : '') + '<strong>' + money(px(it.final_line_price)) + '</strong>' + (kg ? '<span>' + kg.toFixed(2) + ' kg</span>' : '') + '</div></div>';
  }
  function savedHtml() {
    var a = saved();
    if (!a.length) return '';
    return '<section class="isu-ccard isu-saved"><h2 class="isu-cart__h3">Saved for later <span>(' + a.length + ')</span></h2>' + a.map(function (s, i) {
      return '<div class="isu-saved__row"><span class="isu-saved__t">' + e(s.t) + (s.n ? ' <small>' + e(s.n) + '</small>' : '') + '</span><span class="isu-saved__q">' + e(s.lbl || ('× ' + s.q)) + '</span>' +
        '<button type="button" class="isu-link" data-unsave="' + i + '">Move to basket</button><button type="button" class="isu-link isu-link--mute" data-drop-saved="' + i + '">Remove</button></div>';
    }).join('') + '</section>';
  }
  function summaryHtml(t) {
    var total = cart.total_price, ex = Math.round(total / VAT), vat = total - ex;
    var codes = (cart.discount_codes || []).map(function (d) {
      return '<span class="isu-dpill' + (d.applicable ? '' : ' is-bad') + '">' + e(d.code) + (d.applicable ? '' : ' — not valid for this basket') + '<button type="button" data-undisc aria-label="Remove code ' + e(d.code) + '">×</button></span>';
    }).join('');
    var saving = cart.total_discount ? '<div class="isu-sum__r isu-sum__save"><span>Discounts applied</span><span>−' + money(cart.total_discount) + '</span></div>' : '';
    return '<aside class="isu-sum"><div class="isu-sum__card"><h2 class="isu-sum__h">Order summary</h2><div class="isu-sum__in">' +
      saving +
      '<div class="isu-sum__tot"><span>Total (incl. VAT)</span><strong>' + money(total) + '</strong></div>' +
      '<div class="isu-sum__facts"><div><span>Order weight</span><b>' + (t.kg ? t.kg.toFixed(1) + ' kg' : '—') + '</b></div><div><span>Pieces to cut</span><b>' + (t.pcs || '—') + '</b></div></div>' +
      '<form class="isu-disc" data-disc><label class="isu-sr" for="isu-dc">Discount code</label><input id="isu-dc" type="text" placeholder="Discount code" autocomplete="off" value="' + e(st.disc) + '"><button type="submit" class="isu-btn isu-btn--line isu-btn--sm">Apply</button></form>' +
      (codes ? '<div class="isu-dpills">' + codes + '</div>' : '') +
      '<form action="/cart" method="post" class="isu-sum__go" data-checkout-form><button type="submit" name="checkout" class="isu-btn isu-btn--orange isu-btn--wide isu-btn--lg">Secure checkout <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button></form>' +
      '<div class="isu-sum__x" data-xslot></div></div></div>' +
      '<div class="isu-ccard isu-buyers"><h2 class="isu-cart__h3">For buyers &amp; workshops</h2>' +
      '<button type="button" class="isu-buy" data-print><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 3v12M7 10l5 5 5-5M4 21h16"/></svg><span class="isu-l">Download PDF quote</span><span class="isu-s">PDF quote</span></button>' +
      '<button type="button" class="isu-buy" data-mail><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg><span class="isu-l">Email this basket to a colleague</span><span class="isu-s">Email basket</span></button>' +
      '<button type="button" class="isu-buy" data-copy><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/></svg><span class="isu-l" data-copy-l>Copy basket link</span><span class="isu-s" data-copy-l>Copy link</span></button>' +
      '<a class="isu-buy isu-buy--trade" href="' + e(D.trade) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M3 11 12 4l9 7v9H3z"/><path d="M9 20v-6h6v6"/></svg>Larger quantities? Request a trade quote</a></div></aside>';
  }
  function render() {
    if (fb) fb.hidden = true;
    var x = root.querySelector('[data-isu-xpay]');
    if (x && app.contains(x)) { x.hidden = true; root.appendChild(x); }
    if (!cart.items.length) {
      var tpl = root.querySelector('template[data-isu-empty]');
      app.innerHTML = (st.undo ? undoBar() : '') + (tpl ? tpl.innerHTML : '') + '<div class="isu-ce__saved">' + savedHtml() + '</div>';
      root.classList.add('is-empty');
      fillPopular();
      return;
    }
    root.classList.remove('is-empty');
    var t = totals();
    var facts = [t.lines + ' line' + (t.lines === 1 ? '' : 's')];
    if (t.m) facts.push(t.m + ' m of stock');
    if (t.kg) facts.push(t.kg.toFixed(1) + ' kg');
    if (t.longest) facts.push('Longest piece ' + t.longest + ' mm');
    var html = '<div class="isu-cart__top"><div><h1 class="isu-cart__h">Your basket</h1><p class="isu-cart__meta">' + facts.map(function (m) { return '<span>' + m + '</span>'; }).join('') + '</p></div>' +
      '<ol class="isu-steps" aria-label="Checkout steps"><li class="is-on" aria-current="step"><b>1</b>Basket</li><li><b>2</b>Details</li><li><b>3</b>Payment</li></ol></div>' +
      (st.msg ? '<p class="isu-cmsg" role="alert">' + e(st.msg) + '</p>' : '') + (st.undo ? undoBar() : '') +
      '<div class="isu-cart__grid"><div class="isu-cart__main">' +
      '<section class="isu-ccard isu-clist"><div class="isu-clist__h"><h2 class="isu-cart__h3">Cut list</h2></div>' +
      '<div class="isu-clist__cols" aria-hidden="true"><span>Product</span><span>Length &amp; cutting</span><span>Price ' + (st.inc ? 'inc' : 'ex') + ' VAT</span></div>' +
      view().map(lineHtml).join('') +
      '<div class="isu-addsz" data-addsz hidden><div><label for="isu-addsel">Add another size</label><select id="isu-addsel"></select></div><div class="isu-addsz__m"><label for="isu-addq">Metres</label><input id="isu-addq" type="number" min="1" step="1" value="1" inputmode="numeric"></div><button type="button" class="isu-btn isu-btn--navy" data-addsz-go>Add to cut list</button></div></section>' +
      '<section class="isu-ccard isu-notes"><div><label for="isu-po"><b>PO / job reference</b> (optional)</label><input id="isu-po" type="text" data-attr="PO reference" value="' + e((cart.attributes || {})['PO reference'] || '') + '" placeholder="e.g. PO-24518 or Job 112"><small>Printed on your invoice and packing note.</small></div>' +
      '<div><label for="isu-notes"><b>Cutting notes</b> (optional)</label><textarea id="isu-notes" data-note rows="3" placeholder="e.g. Bronze: label each piece. Tolerances or end finish needed.">' + e(cart.note || '') + '</textarea></div></section>' +
      savedHtml() +
      '<section class="isu-often" data-often hidden><h2 class="isu-cart__h2">Often cut alongside</h2><div class="isu-often__g" data-often-g></div></section>' +
      '</div>' + summaryHtml(t) + '</div>' +
      '<div class="isu-sticky"><span><b>' + t.lines + ' line' + (t.lines === 1 ? '' : 's') + '</b>' + (t.kg ? t.kg.toFixed(1) + ' kg' : '') + '</span><button type="button" class="isu-btn isu-btn--orange" data-sticky-go>Secure checkout <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button></div>' +
      printSheet(t);
    app.innerHTML = html;
    if (x) { var slot = app.querySelector('[data-xslot]'); if (slot) { slot.appendChild(x); x.hidden = false; slot.insertAdjacentHTML('afterbegin', '<p class="isu-sum__or"><span>or express checkout</span></p>'); } }
    st.msg = '';
    fillAddSize();
    fillOften();
  }
  function undoBar() {
    return '<div class="isu-undo" role="status"><span>Removed <b>' + e(st.undo.t) + '</b></span><button type="button" class="isu-link" data-undo>Undo</button></div>';
  }
  function printSheet(t) {
    var d = new Date(), date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    var po = (cart.attributes || {})['PO reference'];
    return '<div class="isu-print" aria-hidden="true"><h2>Quotation — ' + e(D.shop) + '</h2><p>' + date + (po ? ' · PO / job: ' + e(po) : '') + '</p><table><thead><tr><th>Item</th><th>Qty</th><th>Cutting</th><th>Line (inc VAT)</th></tr></thead><tbody>' +
      view().map(function (it) {
        if (it.grp) return '<tr><td>' + e(it.product_title) + '</td><td>1</td><td>' + e(grpText(it)) + '</td><td>' + money(it.final_line_price) + '</td></tr>';
        var lin = isLin(it), pcs = lin ? piecesOf(it) : 0;
        return '<tr><td>' + e(it.product_title) + (it.product_has_only_default_variant || (M(it.product_id) || {}).vc === 1 ? '' : ' — ' + e(it.variant_title)) + '</td><td>' + it.quantity + (lin ? ' m' : '') + '</td><td>' + (lin ? cutText(it.quantity, pcs) : '') + '</td><td>' + money(it.final_line_price) + '</td></tr>';
      }).join('') + '</tbody></table><p><b>Total (incl. VAT) ' + money(cart.total_price) + '</b>' + (t.kg ? ' · ' + t.kg.toFixed(1) + ' kg' : '') + '</p>' +
      (cart.note ? '<p>Notes: ' + e(cart.note) + '</p>' : '') + '<p>' + e(D.domain) + '</p></div>';
  }

  /* ---------- add another size / often cut alongside / popular ---------- */
  var addList = [];
  function fillAddSize() {
    var box = app.querySelector('[data-addsz]');
    if (!box) return;
    var first = null;
    cart.items.some(function (it) { var m = M(it.product_id); if (m && m.mat && m.prof && m.lin) { first = m; return true; } return false; });
    if (!first) cart.items.some(function (it) { var m = M(it.product_id); if (m && m.mat && m.prof) { first = m; return true; } return false; });
    if (!first || !S.load) return;
    S.load().then(function (data) {
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
      addList = data.filter(function (p) { return p.av && p.vc === 1 && !inCart[p.id] && p.mat && p.prof && p.mat.k === first.mat.k && p.prof.k === first.prof.k && p.dims.length; }).sort(S.bySize).slice(0, 120);
      var sel = box.querySelector('select');
      if (!addList.length || !sel) return;
      sel.innerHTML = addList.map(function (p, i) { return '<option value="' + i + '">' + e(p.name + ' ' + S.size(p, 'mm') + (p.grade && p.name.indexOf(p.grade) < 0 ? ' — ' + p.grade : '') + ' — ' + money(p.price) + (p.lin ? ' per m' : '')) + '</option>'; }).join('');
      var near = 0, fd = first.sd[0] || 0, best = 1e9;
      addList.forEach(function (p, i) { var d = Math.abs((p.sd[0] || 0) - fd); if (d < best) { best = d; near = i; } });
      sel.value = String(near);
      var syncQ = function () { var p = addList[+sel.value]; var q = box.querySelector('.isu-addsz__m'); if (q) q.style.visibility = p && p.lin ? 'visible' : 'hidden'; };
      sel.addEventListener('change', syncQ); syncQ();
      box.hidden = false;
    }, function () {});
  }
  function rowFromJson(p) {
    var cl = '', lin = 0;
    (p.tags || []).forEach(function (t) { if (t.indexOf('CutLength-') === 0) cl = t.slice(10); if (t === 'Linear Metre') lin = 1; });
    if (cl || /Linear Metre/.test(p.title)) lin = 1;
    if ((p.tags || []).indexOf('metals4u') > -1) { lin = 0; cl = ''; }
    var stag = (p.tags || []).filter(function (t) { return /^\d/.test(t) && t.indexOf('mm') > -1; })[0] || '';
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    return [p.id, p.handle, p.title, p.type || '', stag, p.price, p.price_varies ? 1 : 0, v.id, p.available ? 1 : 0, cl, lin, (p.variants || []).length];
  }
  function card(m, imgUrl) {
    var buy = !m.av ? '<a class="isu-btn isu-btn--line isu-btn--sm" href="/products/' + m.h + '">View</a>' :
      (m.varies || m.vc > 1) ? '<a class="isu-btn isu-btn--navy isu-btn--sm" href="/products/' + m.h + '">Options</a>' :
        '<button type="button" class="isu-btn isu-btn--navy isu-btn--sm" data-quick="' + m.vid + '">+ Add 1' + (m.lin ? ' m' : '') + '</button>';
    var sub = [m.grade, m.kg ? m.kg.toFixed(2) + ' kg/m' : ''].filter(Boolean).join(' · ');
    return '<div class="isu-ocard">' + (imgUrl !== undefined ? '<a class="isu-ocard__img" href="/products/' + m.h + '">' + (imgUrl ? '<img src="' + e(imgUrl) + (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '<span style="background:' + (m.mat ? m.mat.c : '#c8ced6') + '"></span>') + '</a>' : '') +
      '<a class="isu-ocard__t" href="/products/' + m.h + '" title="' + e(m.t) + '">' + e(m.name + (m.dims.length ? ' ' + S.size(m, 'mm') : '')) + '</a>' + (sub ? '<p class="isu-ocard__m">' + e(sub) + '</p>' : '') +
      '<div class="isu-ocard__b"><span class="isu-ocard__p">' + (m.varies ? '<small>from </small>' : '') + money(m.price) + (m.lin ? '<small> /m</small>' : '') + '</span>' + buy + '</div></div>';
  }
  var oftenCache = null;
  function fillOften() {
    var sec = app.querySelector('[data-often]'), g = app.querySelector('[data-often-g]');
    if (!sec || !g || !cart.items.length) return;
    var draw = function (list) {
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
      var ok = list.filter(function (x) { return !inCart[x.m.id] && x.m.av; }).slice(0, 4);
      if (!ok.length) return;
      g.innerHTML = ok.map(function (x) { return card(x.m, x.img); }).join('');
      sec.hidden = false;
    };
    if (oftenCache) return draw(oftenCache);
    fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        oftenCache = (j.products || []).map(function (p) { return { m: S.prep(rowFromJson(p)), img: p.featured_image || '' }; });
        oftenCache.forEach(function (x) { meta[x.m.id] = meta[x.m.id] || x.m; });
        draw(oftenCache);
      }).catch(function () {});
  }
  function fillPopular() {
    app.querySelectorAll('.isu-pcard[data-row]').forEach(function (c) {
      var m;
      try { m = S.prep(JSON.parse(c.getAttribute('data-row'))); } catch (x) { return; }
      c.outerHTML = card(m);
    });
  }

  /* ---------- events ---------- */
  function lineByKey(k) { return view().filter(function (it) { return it.key === k; })[0]; }
  function commit(step) {
    var it = lineByKey(step.getAttribute('data-key')), kind = step.getAttribute('data-kind');
    if (!it) return;
    var v = parseInt(step.querySelector('input').value, 10);
    if (!(v >= 1)) v = 1;
    if (kind === 'len') {
      var probe = { quantity: v, product_id: it.product_id, properties: it.properties };
      var pcs = Math.max(piecesOf(it), minPieces(probe));
      var temp = { quantity: v, properties: it.properties, product_id: it.product_id };
      change(it, v, isLin(it) ? propsFor(temp, pcs) : null);
    } else if (kind === 'pcs') {
      var mn = minPieces(it); if (v < mn) v = mn;
      var mx = Math.max(1, it.quantity * 20); if (v > mx) v = mx;
      change(it, it.quantity, propsFor(it, v));
    } else change(it, v);
  }
  function queue(step) {
    var k = step.getAttribute('data-key') + step.getAttribute('data-kind');
    clearTimeout(timers[k]);
    timers[k] = setTimeout(function () { commit(step); }, 450);
  }
  app.addEventListener('click', function (ev) {
    var b = ev.target.closest('button, a');
    if (!b) return;
    var step = b.closest('.isu-step');
    if (step && b.hasAttribute('data-d')) {
      var inp = step.querySelector('input'), v = (parseInt(inp.value, 10) || 1) + (+b.getAttribute('data-d'));
      if (v < 1) v = 1;
      if (step.getAttribute('data-kind') === 'pcs') { var it0 = lineByKey(step.getAttribute('data-key')); if (it0 && v < minPieces(it0)) v = minPieces(it0); }
      inp.value = v;
      step.querySelector('[data-d="-1"]').disabled = v <= 1;
      queue(step);
      return;
    }
    if (b.hasAttribute('data-vat')) { st.inc = b.getAttribute('data-vat') === 'inc'; try { localStorage.setItem('isu-vat', st.inc ? 'inc' : 'ex'); } catch (x) {} render(); return; }
    if (b.hasAttribute('data-remove') || b.hasAttribute('data-save')) {
      var key = b.getAttribute('data-remove') || b.getAttribute('data-save'), it = lineByKey(key);
      if (!it) return;
      if (it.grp) {
        st.undo = { t: it.product_title, items: it.items.map(function (x) { return { id: x.variant_id, quantity: x.quantity, properties: x.properties }; }) };
        var up = {};
        it.items.forEach(function (x) { up[x.key] = 0; });
        api('/cart/update.js', { updates: up }).then(function (c) { cart = c; badge(); render(); }, refresh);
        return;
      }
      var m = M(it.product_id), entry = { v: it.variant_id, q: it.quantity, p: it.properties || {}, t: m ? m.name : it.product_title, n: m && m.dims.length ? S.size(m, 'mm') : (it.product_has_only_default_variant ? '' : it.variant_title), lbl: isLin(it) ? it.quantity + ' m' : '× ' + it.quantity };
      if (b.hasAttribute('data-save')) { var a = saved(); a.push(entry); setSaved(a); st.undo = null; }
      else st.undo = entry;
      change(it, 0);
      return;
    }
    if (b.hasAttribute('data-undo') && st.undo) {
      var u = st.undo; st.undo = null;
      api('/cart/add.js', { items: u.items || [{ id: u.v, quantity: u.q, properties: u.p }] }).then(refresh, refresh);
      return;
    }
    if (b.hasAttribute('data-unsave')) {
      var list = saved(), s = list[+b.getAttribute('data-unsave')];
      if (!s) return;
      list.splice(+b.getAttribute('data-unsave'), 1); setSaved(list);
      api('/cart/add.js', { items: [{ id: s.v, quantity: s.q, properties: s.p }] }).then(function () { location.reload(); }, function () { st.msg = 'That item is no longer available.'; render(); });
      return;
    }
    if (b.hasAttribute('data-drop-saved')) { var l2 = saved(); l2.splice(+b.getAttribute('data-drop-saved'), 1); setSaved(l2); render(); return; }
    if (b.hasAttribute('data-addsz-go')) {
      var sel = app.querySelector('#isu-addsel'), p = addList[+sel.value], q = Math.max(1, parseInt(app.querySelector('#isu-addq').value, 10) || 1);
      if (!p) return;
      b.disabled = true; b.textContent = 'Adding…';
      api('/cart/add.js', { items: [{ id: p.vid, quantity: p.lin ? q : 1 }] }).then(function () { location.reload(); }, function (err) { b.disabled = false; b.textContent = 'Add to cut list'; st.msg = (err && err.description) || 'Could not add that size.'; render(); });
      return;
    }
    if (b.hasAttribute('data-quick')) {
      b.disabled = true; b.textContent = 'Adding…';
      api('/cart/add.js', { items: [{ id: +b.getAttribute('data-quick'), quantity: 1 }] }).then(function () { location.reload(); }, function () { b.disabled = false; b.textContent = 'Try again'; });
      return;
    }
    if (b.hasAttribute('data-undisc')) { api('/cart/update.js', { discount: '' }).then(function (c) { cart = c; render(); }, refresh); return; }
    if (b.hasAttribute('data-print')) { window.print(); return; }
    if (b.hasAttribute('data-mail')) {
      var lines = view().map(function (it) { if (it.grp) return '- ' + it.product_title + ': ' + grpText(it) + ' = ' + money(it.final_line_price); var lin = isLin(it); return '- ' + it.product_title + (it.product_has_only_default_variant ? '' : ' (' + it.variant_title + ')') + ': ' + it.quantity + (lin ? ' m, cut ' + cutText(it.quantity, piecesOf(it)) : '') + ' = ' + money(it.final_line_price); });
      var body = 'Basket from ' + D.shop + '\n\n' + lines.join('\n') + '\n\nTotal inc VAT: ' + money(cart.total_price) + '\n\nOpen this basket: ' + link();
      window.location.href = 'mailto:?subject=' + encodeURIComponent('Basket from ' + D.shop) + '&body=' + encodeURIComponent(body);
      return;
    }
    if (b.hasAttribute('data-copy')) {
      var labs = b.querySelectorAll('[data-copy-l]'), url = link();
      var done = function () { var old = []; labs.forEach(function (l, i) { old[i] = l.textContent; l.textContent = 'Link copied'; }); setTimeout(function () { labs.forEach(function (l, i) { l.textContent = old[i]; }); }, 2500); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
      else window.prompt('Copy this link', url);
      return;
    }
    if (b.hasAttribute('data-sticky-go')) { var f = app.querySelector('[data-checkout-form]'); if (f) { if (f.requestSubmit) f.requestSubmit(f.querySelector('[name="checkout"]')); else f.querySelector('[name="checkout"]').click(); } }
  });
  function link() { return (D.domain || location.origin) + '/cart/' + cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(','); }
  app.addEventListener('change', function (ev) {
    var t = ev.target;
    var step = t.closest && t.closest('.isu-step');
    if (step) { queue(step); return; }
  });
  app.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && ev.target.closest && ev.target.closest('.isu-step')) { ev.preventDefault(); commit(ev.target.closest('.isu-step')); }
  });
  var noteTimer = 0;
  app.addEventListener('input', function (ev) {
    var t = ev.target;
    if (t.hasAttribute('data-note') || t.hasAttribute('data-attr')) {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        var body = {};
        if (t.hasAttribute('data-note')) body.note = t.value;
        else { body.attributes = {}; body.attributes[t.getAttribute('data-attr')] = t.value; }
        api('/cart/update.js', body).then(function (c) { cart.note = c.note; cart.attributes = c.attributes; }, function () {});
      }, 600);
    }
  });
  app.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f.hasAttribute('data-disc')) {
      ev.preventDefault();
      var code = f.querySelector('input').value.trim();
      if (!code) return;
      st.disc = '';
      api('/cart/update.js', { discount: code }).then(function (c) { cart = c; render(); }, function () { st.msg = 'That code could not be applied.'; render(); });
      return;
    }
    if (f.hasAttribute('data-isu-find')) {
      ev.preventDefault();
      var q = [f.m.value, f.p.value, f.s.value].join(' ').replace(/\s+/g, ' ').trim();
      var len = parseInt(f.len.value, 10) || 1;
      window.location.href = '/search?type=product&q=' + encodeURIComponent(q) + (len > 1 ? '&len=' + len : '');
    }
  });

  /* one-off: write the automatic split into the order for lines longer than the longest bar */
  var tried = {};
  function autoSplit() {
    var it = cart.items.filter(function (x) { return !tried[x.variant_id] && isLin(x) && !(x.properties && x.properties['Cut into']) && minPieces(x) > 1; })[0];
    if (!it) return;
    tried[it.variant_id] = 1;
    change(it, it.quantity, propsFor(it, minPieces(it))).then(autoSplit);
  }
  render();
  autoSplit();
})();
